import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";

export const GET_LIST_FORM = "GET_LIST_FORM";
export const GET_LIST_FORM_ERROR = "GET_LIST_FORM_ERROR";
export const GET_LIST_FORM_SUCCESS = "GET_LIST_FORM_SUCCESS";

export const GET_A_FORM = "GET_A_FORM";
export const GET_A_FORM_ERROR = "GET_A_FORM_ERROR";
export const GET_A_FORM_SUCCESS = "GET_A_FORM_SUCCESS";

export const COUNT_LIST_FORM = "COUNT_LIST_FORM";
export const COUNT_LIST_FORM_ERROR = "COUNT_LIST_FORM_ERROR";
export const COUNT_LIST_FORM_SUCCESS = "COUNT_LIST_FORM_SUCCESS";

export const ADD_NEW_FORM = "ADD_NEW_FORM";
export const ADD_NEW_FORM_ERROR = "ADD_NEW_FORM_ERROR";
export const ADD_NEW_FORM_SUCCESS = "ADD_NEW_FORM_SUCCESS";

export const EDIT_A_FORM = "EDIT_A_FORM";
export const EDIT_A_FORM_SUCCESS = "EDIT_A_FORM_SUCCESS";
export const EDIT_A_FORM_ERROR = "EDIT_A_FORM_ERROR";

export const DELETE_A_FORM = "DELETE_A_FORM";
export const DELETE_A_FORM_SUCCESS = "DELETE_A_FORM_SUCCESS";
export const DELETE_A_FORM_ERROR = "DELETE_A_FORM_ERROR";

/**
 * Reducer
 */

const initialState = {
  forms: [],
  error: false,
  count: 0,
  loading: false,
};

export const formsReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_FORM:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        forms: action.payload,
      };
    case GET_LIST_FORM_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //count list
    case COUNT_LIST_FORM:
      return {
        ...state,
      };
    case COUNT_LIST_FORM_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_FORM_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_FORM:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        form: action.payload,
      };
    case ADD_NEW_FORM_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //edit
    case EDIT_A_FORM:
      return {
        ...state,
        loading: true,
      };
    case EDIT_A_FORM_SUCCESS: {
      const newItems = state.forms.filter((item) => item.id !== action.data.id);
      return {
        ...state,
        loading: false,
        newItems,
      };
    }
    case EDIT_A_FORM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_FORM:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        form: action.payload,
      };
    case DELETE_A_FORM_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //get one
    case GET_A_FORM:
      return {
        ...state,
        loading: true,
      };
    case GET_A_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        form: action.payload,
      };
    case GET_A_FORM_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListForm = (
  order,
  limit,
  skip,
  where,
  include,
  query = null
) => ({
  type: GET_LIST_FORM,
  data: {
    order,
    limit,
    skip,
    where,
    include,
    query,
  },
});

export const countListForm = (where, include) => ({
  type: COUNT_LIST_FORM,
  data: {
    where,
    include,
  },
});

export const addNewForm = (name, campaignId, questions, note, content) => ({
  type: ADD_NEW_FORM,
  data: {
    name,
    campaignId,
    questions,
    note,
    content,
  },
});

export const editForm = (id, name, campaignId, questions, note, content) => ({
  type: EDIT_A_FORM,
  data: {
    id,
    name,
    campaignId,
    questions,
    note,
    content,
  },
});

export const deleteForm = (id) => ({
  type: DELETE_A_FORM,
  data: {
    id,
  },
});

export const getAForm = (id) => ({
  type: GET_A_FORM,
  data: {
    id,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListForm,
      countListForm,
      addNewForm,
      editForm,
      deleteForm,
      getAForm,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListFormApi = (order, limit, skip, where, include, query) => {
  return apiCaller.getLogs(
    "/mini-crm/form",
    { order, limit, skip, ...where, include },
    query
  );
};

const countListFormApi = (where, include) => {
  return apiCaller.getData("/mini-crm/form/count", { ...where, include });
};
const addNewFormApi = (name, campaignId, questions, note, content) => {
  return apiCaller.post("/mini-crm/form", {
    name,
    campaignId,
    ...questions,
    note,
    content,
  });
};
const editFormApi = (id, name, campaignId, questions, note, content) => {
  return apiCaller.put(`/mini-crm/form/${id}`, {
    name,
    campaignId,
    ...questions,
    note,
    content,
  });
};
const deleteFormApi = (id) => {
  return apiCaller.del(`/mini-crm/form/${id}`);
};
const getAFormApi = (id) => {
  return apiCaller.getLogs(`/mini-crm/form/${id}`);
};

/**
 * sagas
 */

export const getListFormFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_FORM);
    try {
      const res = yield call(
        getListFormApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.include,
        action.data.query
      );
      yield put({ type: GET_LIST_FORM_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LIST_FORM_ERROR, error });
    }
  }
};

export const countFormFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_FORM);
    try {
      const res = yield call(
        countListFormApi,
        action.data.where,
        action.data.include
      );
      yield put({ type: COUNT_LIST_FORM_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: COUNT_LIST_FORM_ERROR, error });
    }
  }
};

export const addNewFormFlow = function* () {
  while (true) {
    const action = yield take(ADD_NEW_FORM);
    try {
      const res = yield call(
        addNewFormApi,
        action.data.name,
        action.data.campaignId,
        action.data.questions,
        action.data.note,
        action.data.content
      );
      yield put({ type: ADD_NEW_FORM_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: ADD_NEW_FORM_ERROR, error });
    }
  }
};

export const editFormFlow = function* () {
  while (true) {
    const action = yield take(EDIT_A_FORM);
    try {
      const res = yield call(
        editFormApi,
        action.data.id,
        action.data.name,
        action.data.campaignId,
        action.data.questions,
        action.data.note,
        action.data.content
      );
      yield put({ type: EDIT_A_FORM_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_A_FORM_ERROR, error });
    }
  }
};

export const deleteFormFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_FORM);
    try {
      const res = yield call(deleteFormApi, action.data.id);
      yield put({ type: DELETE_A_FORM_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: DELETE_A_FORM_ERROR, error });
    }
  }
};

export const getAFormFlow = function* () {
  while (true) {
    const action = yield take(GET_A_FORM);
    try {
      const res = yield call(getAFormApi, action.data.id);
      yield put({ type: GET_A_FORM_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_A_FORM_ERROR, error });
    }
  }
};
